import React, { useState } from "react";
import styled from "styled-components";
import { CompassParagraph } from "../common/styledComponents";
import { ElementContainer } from "../containers/styledComponents";
import { darkGreen, greyText } from "../../styles";

const Button = styled.div<{ isLeftButton: boolean; isActive: boolean }>`
  display: flex;
  min-width: 75px;
  height: 25px;
  padding: 13px 15px;
  align-items: center;
  justify-content: flex-end;
  border-radius: ${({ isLeftButton }): string =>
    isLeftButton ? "6px 0 0 6px" : "0 6px 6px 0"};
  border: 1px solid #e2e7e7;
  background-color: ${({ isActive }): string =>
    isActive ? "white" : "#f8f9fa"};
  cursor: pointer;
`;

export const ToggleOptionsButton = ({
  options,
  handleOptionChange,
}: ToggleOptionsButtonProps): JSX.Element => {
  const [activeOption, setActiveOption] = useState(0); // Default to the first option

  const handleButtonClick = (index: number): void => {
    setActiveOption(index);
    handleOptionChange && handleOptionChange(options[index]);
  };

  return (
    <ElementContainer>
      {options.map((option, index) => (
        <Button
          key={index}
          isLeftButton={index === 0}
          isActive={activeOption === index}
          onClick={(): void => handleButtonClick(index)}
        >
          <CompassParagraph
            color={activeOption === index ? darkGreen : greyText}
          >
            {option}
          </CompassParagraph>
        </Button>
      ))}
    </ElementContainer>
  );
};

interface ToggleOptionsButtonProps {
  options: string[];
  handleOptionChange?: (option: string) => void;
}
